






import { Component, Vue, Model, Emit } from 'vue-property-decorator';
import SearchPaginationTable from '@/components/search-pagination-table.vue';
import DialogTable from '@/components/dialog-table.vue';
import moment from 'moment';
import { post, get } from '@/unite/api';
import Dialog from '@/components/dialog.vue';
@Component({
  components: { SearchPaginationTable, Dialog, DialogTable }
})
export default class LargeOrderList extends Vue {
  visible: boolean = false;
  pageData: any = {
    url: '/api/getAccountList',
    isSearch: true, // 是否需要搜索框
    isPagination: true, // 是否后端分页
    isBtn: true, // 是否需要头部操作按钮
    info: {
      account: '',
      page_size: 10,
      page_no: 1
    }, // 传后端数据
    searchData: [
      {
        type: 'input', // text框
        model: 'account', // 字段
        tip: '账户名称',
        placeholder: '请输入账户名称'
      }
    ],
    btnData: [
      {
        name: '添加账号',
        methods: 'add',
        type: 'primary',
        loading: false
      },
      {
        name: '刷新列表',
        methods: 'refesh',
        type: 'success',
        loading: false
      },
      {
        name: '导出列表',
        methods: 'downAll',
        type: 'downAll',
        loading: false
      }
    ],
    tableData: {
      stripe: false,
      border: true,
      expandShow: false,
      optionShow: true,
      tableRowClassName: function(tableData: any) {
        if (tableData.row.card_status === 4) {
          return 'success3-row';
        }
        return '';
      },
      header: [
        {
          prop: 'id',
          label: 'ID'
        },
        {
          prop: 'account',
          label: '帐号'
        },
        {
          prop: 'merchant_name',
          label: '所属商户名称'
        },
        {
          prop: 'Enable', // 显示字段
          _prop: 'enable', // 原字段
          label: '是否启用',
          status: {
            true: '是',
            false: '否'
          }
        }
      ],
      expand: [],
      optionWidth: '180px',
      option: [
        {
          name: '禁用',
          methods: 'disable',
          type: 'warning',
          role: function(row: any) {
            return row.enable;
          }
        },
        {
          name: '启用',
          methods: 'open',
          type: 'primary',
          role: function(row: any) {
            return !row.enable;
          }
        },
        {
          name: '重置验证码',
          methods: 'reset',
          type: 'primary',
          role: function(row: any) {
            return 1;
          }
        }
      ]
    }
  };
  dialogData: any = {
    optionTitle: '添加账号',
    modifyForm: {
      url: '/api/addAccount',
      width: '700px',
      form: {
        account: '',
        password: '',
        merchant_id: 0,
        is_manager: false
      },
      showData: [],
      formLabelWidth: '100px',
      data: [
        {
          type: 'input',
          model: 'account',
          name: '账号名称'
        },
        {
          type: 'input',
          model: 'password',
          name: '密码'
        },
        {
          type: 'switch',
          model: 'is_manager',
          name: '是否管理员'
        },
        {
          type: 'selectFilter',
          model: 'merchant_id',
          name: '所属商户'
        }
      ],
      select: {
        parent_id: []
      }
    },
    rules: {
      account: [
        {
          required: true,
          message: '请输入账号名称',
          trigger: 'blur'
        }
      ],
      password: [
        {
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }
      ]
    }
  };
  mounted() {
    // this.getAmounts();
  }
  created() {
    // console.log(this.api.get('/api/apply/list', this.pageData.info))
  }
  btnClick(methods: string) {
    if (methods === 'add') {
      post('/api/getMainMerchantList', {
        Name: '',
        page_size: 100000,
        page_no: 1
      })
        .then(d => {
          // @ts-ignore
          this.$refs.table.loading = false;
          this.dialogData.modifyForm.select.merchant_id = [
            { value: 0, label: '无' }
          ];
          //@ts-ignore
          d.data.Data.forEach(item => {
            this.dialogData.modifyForm.select.merchant_id = [
              ...this.dialogData.modifyForm.select.merchant_id,
              { value: item.id, label: item.name }
            ];
          });
          this.visible = true;
        })
        .catch(e => {
          // @ts-ignore
          this.$refs.table.loading = false;
        });
    }
  }
  handleClick(methods: string, row: any) {
    if (methods === 'disable' || methods === 'open') {
      let msg = methods === 'disable' ? '禁用' : '开启';
      let info = {
        id: row.id,
        enable: true
      };
      info.enable = methods === 'disable' ? false : true;
      this.$confirm(
        `此操作将${msg}选中账号（用户：${row.account}）, 是否继续?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          post('/api/updateAccount', info)
            .then(d => {
              this.$message({
                type: 'success',
                message: `${msg}成功!`
              });
              // @ts-ignore
              this.$refs.table.getData();
            })
            .catch(e => {});
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: `已取消${msg}`
          });
        });
    } else {
      this.$confirm(
        `此操作重置选中账号谷歌验证码（用户：${row.account}）, 是否继续?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          post('/api/resetAccountSecret', { account: row.account })
            .then(d => {
              this.$message({
                type: 'success',
                message: `重置成功!`
              });
              // @ts-ignore
              this.$refs.table.getData();
            })
            .catch(e => {});
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: `已取消重置`
          });
        });
    }
  }
  // 刷新列表
  refesh(bool: boolean) {
    if (bool) {
      // @ts-ignore
      this.$refs.table.getData();
    }
    this.visible = false;
  }
}
